import {UPDATE_DOWNLOAD_COUNT} from '../actions/PanelHeader';

const initialState = {
    downloadCount: [],
};


const panelHeaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_DOWNLOAD_COUNT:
            return {
                downloadCount: action.payload.downloadCount
            };
        default:
            return state
    }
};


export default panelHeaderReducer;
